// Libs
import classNames from 'classnames/bind';
import { IconArrowOpenEndLine, IconArrowOpenStartLine, IconButton, TextInput, View } from '@instructure/ui';
import { DEFAULT_PAGE } from '~/utils/constants/common';
// Components, Layouts, Pages
// Others
// Styles, images, icons
import styles from './BasePagination.module.scss';

type Props = {
  currentPage?: number;
  hasMore?: boolean;
  onChange?: (page: number) => void;
};

const cx = classNames.bind(styles);

const BasePagination = (props: Props) => {
  //#region Destructuring Props
  const { currentPage = DEFAULT_PAGE, hasMore = true, onChange } = props;
  //#endregion Destructuring Props

  //#region Declare Hook
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  //#endregion Declare State

  //#region Declare Memo
  //#endregion Declare Memo

  //#region Implement Hook
  //#endregion Implement Hook

  //#region Handle Function
  const handleChangeValue = (value: string | number) => {
    if (isNaN(Number(value)) || Number(value) <= 0) return;

    onChange && onChange(value ? Number(value) : 0);
  };
  //#endregion Handle Function

  return (
    <>
      {((currentPage === DEFAULT_PAGE && hasMore) || currentPage !== DEFAULT_PAGE) && (
        <View className={cx('paginationContainer')}>
          <IconButton
            withBorder={false}
            withBackground={false}
            screenReaderLabel={'Previous'}
            disabled={currentPage <= DEFAULT_PAGE}
            onClick={() => handleChangeValue(currentPage - 1)}
          >
            {<IconArrowOpenStartLine />}
          </IconButton>

          <TextInput
            type={'tel'}
            width='50px'
            textAlign='center'
            value={currentPage.toString()}
            onChange={(e, newValue) => handleChangeValue(newValue)}
          />

          <IconButton
            withBorder={false}
            withBackground={false}
            screenReaderLabel={'Next'}
            disabled={!hasMore}
            onClick={() => handleChangeValue(currentPage + 1)}
          >
            {<IconArrowOpenEndLine />}
          </IconButton>
        </View>
      )}
    </>
  );
};

export default BasePagination;
